<ng-container *ngIf="selectIsPongoPluginEnabled | async">
  <ng-container *ngIf="customer">
    <div
      class="bg-neutral-100 mb-5 lg:rounded lg:rounded-s"
      [ngClass]="{
        'max-w-md mx-auto lg:max-w-4xl': width === 'centered',
        'w-full': width === 'full',
      }"
    >
      <div
        class="flex justify-between items-center px-5 pt-6 pb-2"
        *ngIf="heading"
      >
        <h2 class="font-accent font-bold text-2xl lg:text-3xl text-neutral-800">
          {{ heading | translate }}
        </h2>
      </div>
      <div
        class="text-sm lg:text-base px-5 pb-2 font-base text-neutral-600"
        *ngIf="subheading"
      >
        {{ subheading }}
      </div>
      <div
        class="text-sm lg:text-base px-5 pb-2 font-base text-neutral-600 flex flex-row items-center"
      >
        <i class="icon icon-coins pr-1.5 mt-0.5"></i>
        <ng-container *ngIf="!customer.points">
          <span
            [translate]="'pongo.amount-of-0-point'"
            [translateParams]="{ value: 'world' }"
          ></span>
        </ng-container>
        <ng-container *ngIf="customer.points">
          <span
            [translate]="'pongo.amount-of-points'"
            [translateParams]="{ points: customer.points }"
          ></span>
        </ng-container>
      </div>
      <div
        class="text-sm lg:text-base px-5 pb-6 pt-2 font-base text-neutral-600"
        *ngIf="!assets || assets.length === 0"
      >
        {{ 'pongo.no-assets' | translate }}
      </div>
      <ng-container *ngIf="!isDesktop">
        <ul
          class="flex overflow-x-auto px-5 pt-2 pb-8 scrollbar-hide"
          *ngIf="assets.length > 0"
        >
          <li
            class="pr-3 flex-shrink-0 flex-grow-0 w-6/12 max-w-56"
            *ngFor="let asset of assets"
          >
            <ng-container *ngTemplateOutlet="assetCard; context: { asset }"></ng-container>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="isDesktop">
        <div class="overflow-x-auto px-5 pt-2 pb-8">
          <app-card-carousel
            [carouselItem]="productTemplate1"
            [nbDisplayCards]="itemsToShowCardCarousel"
            [cards]="assets"
          >
          </app-card-carousel>
        </div>

        <ng-template
          #productTemplate1
          let-asset
        >
          <div class="flex-1 items-stretch rounded-lg bg-white shadow-S overflow-hidden">
            <ng-container *ngTemplateOutlet="assetCard; context: { asset }"></ng-container>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template
  #assetCard
  let-asset="asset"
>
  <div
    class="h-full flex justify-between flex-col rounded-lg bg-white shadow-S overflow-hidden"
    [ngClass]="{
      'opacity-50': !asset.is_usable && !asset.is_buyable,
    }"
  >
    <div
      *ngIf="asset.picture_url"
      class="flex-shrink-0 bg-neutral-50"
      style="aspect-ratio: 1"
    >
      <img
        [src]="asset.picture_url"
        class="object-contain"
        style="aspect-ratio: 1"
      />
    </div>
    <div class="px-4 py-4 h-full text-sm flex flex-col justify-between">
      <div>
        <p class="text-base lg:text-md font-bold font-base leading-5 pt-1 mb-2">
          {{ asset.name }}
        </p>
        <p *ngIf="!asset.is_usable && asset.is_buyable">
          {{ 'pongo.buy-for-points' | translate: asset }}
        </p>
        <p *ngIf="!asset.is_usable && !asset.is_buyable">
          {{ 'pongo.accessible-in-points' | translate: asset }}
        </p>
      </div>

      <div class="mt-6 flex flex-col items-center justify-center">
        <div
          class="flex flex-row items-center justify-center mb-2 font-normal text-sm leading-snug lg:text-base"
          *ngIf="isAssetInCart(asset)"
        >
          <i class="icon icon-check-circle text-success-600 mr-2"></i>
          {{ 'pongo.asset-added-to-cart' | translate }}
        </div>
        <app-button-atom
          *ngIf="asset.is_usable && !isAssetInCart(asset)"
          [label]="'pongo.use-voucher' | translate"
          (click)="useAsset(asset)"
          icon="icon-plus"
          size="XS"
          thickSize="XS"
          type="outlined"
          color="neutral"
        ></app-button-atom>
        <app-button-atom
          *ngIf="asset.is_usable && isAssetInCart(asset)"
          [label]="'pongo.remove-voucher' | translate"
          (click)="removeAsset(asset)"
          icon="icon-c-remove"
          size="XS"
          thickSize="XS"
          type="outlined"
          color="neutral"
        ></app-button-atom>
        <app-button-atom
          *ngIf="asset.is_buyable"
          [label]="'pongo.buy-voucher' | translate"
          (click)="buyAsset(asset)"
          [icon]="asset.buyInProcess ? undefined : 'icon-plus'"
          [iconUrl]="asset.buyInProcess ? 'assets/images/spinner.svg' : undefined"
          size="XS"
          thickSize="XS"
          type="outlined"
          color="neutral"
        ></app-button-atom>
      </div>
    </div>
  </div>
</ng-template>
